import { TweenMax } from 'gsap';
import App from '../../../vendor_core/core/src/App';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { IOverlayData, OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import { State } from '../../../vendor_core/core/src/states/State';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import BBModel from '../model/BBModel';
import BBReelGroup from '../view/BBReelGroup';

export default class BBMoveCascadeSymbolState extends State {
    public enter(): void {
        super.enter();
        this.playAnimations();
    }

    protected playAnimations(){
        SoundController.playSound('wild_movement');
        this.playWalking().then(()=>{
            ConsoleUtil.green("Move anim finish !!!!");
            this.exit()
        });
    }

    protected playWalking():Promise<boolean>{
        let overlays: IOverlayData[] = [];
        if (BBModel.hasOverlay(OverlayType.Moving)) {
            overlays.push(...BBModel.getOverlays(OverlayType.Moving))
        }
        let promises = [];
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;
        // debugger;
        overlays.forEach(overlay => {
            promises.push(reelGroup.winSymbolsView.moveSpineSymbols(overlay));
        });

        return PromiseHelpers.combineParallel(promises);
    }
}
